module.exports = __webpack_public_path__ + "static/media/CTLI_8-147w.a945f37e.webp";